import { render, staticRenderFns } from "./TarifOverview.vue?vue&type=template&id=aeefe0e2"
import script from "./TarifOverview.vue?vue&type=script&lang=js"
export * from "./TarifOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports